// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
import i18n from './lang'

// import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import VueRouter from 'vue-router'

import App from './App'
import store from './store'
import router from './router'

import '@/permission' // permission control
import '@/icons' // icon
import moment from 'moment'
import VideoPlayer from 'vue-video-player'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import 'video.js/dist/video-js.css'
require('vue-video-player/src/custom-theme.css')

Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

// Vue.use(ElementUI, { locale })
Vue.use(VideoPlayer)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(VueRouter)
Vue.use(moment)

Vue.config.productionTip = false
Vue.prototype.$moment = moment

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js